var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading && _vm.showLoader)?_c('LoaderImg'):(!_vm.loading)?_c('img',{attrs:{"src":_vm.image,"alt":_vm.name}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }